import React from "react";
import { createService } from "~/hocs/crud";
import * as model from "./model";

const STATUS_CLASS_BY_LABEL: Record<string, string> = {
    Ready: "steering-data-status--ready",
    Processing: "steering-data-status--processing",
    Failed: "steering-data-status--failed",
    Pending: "steering-data-status--pending",
};

// Renders the status label with a color class (green Ready, orange Processing,
// red Failed, neutral Pending). Returned via the DataTable service `printer`.
const printEmbeddingStatus = (value: string) =>
    React.createElement(
        "span",
        {
            className: `steering-data-status ${
                STATUS_CLASS_BY_LABEL[value] || "steering-data-status--pending"
            }`,
        },
        value
    );

export const MODEL_NAME = "steeringDataSetup";
export const REQUEST_PAYLOAD_FILTER = "steeringDataFilter";
export const REQUEST_PAYLOAD_SORT_LIST = "steeringDataSortList";
export const REQUEST_PAYLOAD_PAGE_OPTIONS = "steeringDataPageOptions";

export const defaultRequestFilters = {
    [REQUEST_PAYLOAD_FILTER]: {
        [model.PROPS_NAME]: "",
        [model.PROPS_LOCATION]: "",
        [model.PROPS_FILE_NAME]: "",
        [model.PROPS_LAST_MODIFIED]: "",
    },
    [REQUEST_PAYLOAD_SORT_LIST]: [
        {
            Sort: {
                Direction: "ASC",
                Order: 0,
            },
        },
    ],
    [REQUEST_PAYLOAD_PAGE_OPTIONS]: {
        pageSize: 50,
        skip: 0,
    },
};

export const defaultSort = {
    FieldName: "Name",
    Sort: {
        Direction: "ASC",
        Order: 0,
    },
};

export const service = createService({
    guid: model.PROPS_STEERING_DATA_GUID,
    id: "steeringData",
    recordName: "steeringDataGuid",
    model: MODEL_NAME,
    defaultRequestFilters,
    REQUEST_PAYLOAD_FILTER,
    REQUEST_PAYLOAD_SORT_LIST,
    REQUEST_PAYLOAD_PAGE_OPTIONS,
    _defaultLabels: {
        [model.PROPS_NAME]: {
            label: "name",
            gridCol: 20,
        },
        [model.PROPS_LOCATION]: {
            label: "location",
            gridCol: 25,
        },
        [model.PROPS_FILE_NAME]: {
            label: "fileName",
            gridCol: 25,
        },
        [model.PROPS_LAST_MODIFIED]: {
            label: "lastModified",
            gridCol: 18,
        },
        [model.PROPS_EMBEDDING_STATUS]: {
            label: "embeddingStatus",
            gridCol: 12,
        },
    },
    printer: {
        [model.PROPS_EMBEDDING_STATUS]: printEmbeddingStatus,
    },
    // Keep the cell tooltip as the plain status text (the printer returns JSX).
    getTitleValue: (record: Record<string, unknown>, attr: string) => record[attr],
    defaultSort,
});
